<template>
    <div class="painel-page mb-0" v-if="(order.tipo.includes('Boleto') || order.tipo.includes('Fatura_Mensal')) && hasMultipleUnpaid">
        <div class="painel-page-inner-v2">
            <div class="row">
                <div class="col-md-9 d-flex align-items-center"></div>
                <div class="col-md-3">
                    <div v-if="loading" class="btn btn-block btn-primary">
                        <b-spinner variant="light"></b-spinner>
                    </div>
                    <div v-else v-on:click="download(order)" class="btn btn-block btn-primary"> {{ $t('Imprimir Carnê') }} </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        order: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        async download() {
            window.open(`/painel/payment/order/${this.order.id}/bundle`, '_blank').focus()
        }
    },
    computed: {
        hasMultipleUnpaid() {
            return this.order.invoices.filter(i => i.status === 'np').length > 1
        }
    },
}
</script>
